import { defaultFontInput } from './constants/fontFamilies';

const FableticsRewardCountDownToPlatinumBuilderComponent = {
  name: '_LoyaltyPlatinumCountdown_',
  inputs: [defaultFontInput],
} as const;

export default FableticsRewardCountDownToPlatinumBuilderComponent;
